// extracted by mini-css-extract-plugin
module.exports = {"sectionCoursesThankyou":"Detail_sectionCoursesThankyou_3BFmQ","notice":"Detail_notice_1b2i8","finishWrapper":"Detail_finishWrapper_9d-u9","finish":"Detail_finish_Doj7g"};